/** The enter / exit full-screen glyph both film players share. */
const ENTER = 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5';
const EXIT = 'M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5';

export function FullscreenGlyph({ exit = false }: { exit?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d={exit ? EXIT : ENTER} />
    </svg>
  );
}
